export const COLORS = {
    cldPills: '#002040'
}